import React, { useState, useEffect } from 'react'
import { Input, Button, Dialog, WaterMark, Toast, NavBar } from 'antd-mobile'
import { useNavigate } from "react-router-dom";
import * as api from '../../services/api';
import { useOKRequest } from '../../hooks';
import { getAuth, clearAuth } from '../../modules/auth';
import './modifyPassword.css';

function ModifyPassword() {
  const navigate = useNavigate();
  // useEffect(() => {
  //   document.title = '修改密码'; // 修改页面标题 
  // }, [])
  const [visibleOld, setVisibleOld] = useState(false)
  const [visibleNew, setVisibleNew] = useState(false)
  const [visibleConfirm, setVisibleConfirm] = useState(false)
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errors, setErrors] = useState({ oldPassword: false, newPassword: false, confirmPassword: false });

  // 修改密码接口
  const { loading, run: updateUserRealPwd } = useOKRequest(api.updateUserRealPwd, {
    manual: true,
    onSuccess: (res) => {
      if (res.data.code === 200) {
        Toast.show({
          content: '修改成功，请重新登录',
        })
        setTimeout(() => {
          navigate('/')
          clearAuth()
        }, 500)
      } else {
        Toast.show({
          content: res.data.message,
        })
      }
    },
  });

  const showDialog = (message) => {
    Dialog.show({
      content: <div className='ModifyPassword_errorTip'>{message}</div>,
      closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: <div className='ModifyPassword_action'>确定</div>,
          },
        ],
      ],
    });
  };

  const handleInputChange = (name, value) => {
    if (name === 'oldPassword') setOldPassword(value);
    if (name === 'newPassword') setNewPassword(value);
    if (name === 'confirmPassword') setConfirmPassword(value);
    // 输入值时清除错误状态，清空值时添加错误信息
    if (value) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: false,
      }));
    } else {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: true,
      }));
    }
  };

  const onsubmit = () => {
    // 检测参数是否为空
    const newErrors = { oldPassword: !oldPassword, newPassword: !newPassword, confirmPassword: !confirmPassword };
    // 更新错误状态
    setErrors(newErrors);
    if (!oldPassword) {
      showDialog('请输入旧密码');
      return;
    }
    if (!newPassword) {
      showDialog('请输入新密码');
      return;
    }
    if (!confirmPassword) {
      showDialog('请输入确认密码');
      return;
    }
    if (newPassword !== confirmPassword) {
      showDialog('两次输入的密码不一致');
      return;
    }
    const params = {
      oldPassword: oldPassword,
      realPassword: newPassword,
      // confirmpassword: confirmPassword,
      username: getAuth().username,
    }
    console.log('params', params)
    updateUserRealPwd(params)
  }

  return (
    <div className='ModifyPassword'>
      <NavBar
        // back='修改密码'
        onBack={() => navigate(-1)}>
        修改密码
      </NavBar>
      <WaterMark fontColor='rgba(0, 0, 0, .1)' content={[getAuth()?.depart_name, getAuth()?.realname]} />
      <div style={{ paddingTop: '20%' }}>
        <div className="ModifyPassword_formItem">
          <div className="ModifyPassword_itemText">
            <div className='ModifyPassword_itemIcon'>*</div>
            旧密码：
          </div>
          <div
            className={`ModifyPassword_formInput ${errors.oldPassword ? 'error-border' : ''}`}
            style={{ padding: '0 16px' }}
          >
            <Input
              className='input'
              placeholder='输入旧密码'
              type={visibleOld ? 'text' : 'password'}
              value={oldPassword}
              onChange={val => handleInputChange('oldPassword', val)}
            />
            <div className='eye'>
              {!visibleOld ? (
                <img
                  src="./images/eyesIcon1.png"
                  alt=""
                  onClick={() => setVisibleOld(true)}
                />
              ) : (
                <img
                  src="./images/eyesIcon2.png"
                  alt=""
                  onClick={() => setVisibleOld(false)}
                />
              )}
            </div>
          </div>
        </div>
        <div className="ModifyPassword_formItem">
          <div className="ModifyPassword_itemText">
            <div className='ModifyPassword_itemIcon'>*</div>
            新密码：
          </div>
          <div
            className={`ModifyPassword_formInput ${errors.newPassword ? 'error-border' : ''}`}
            style={{ padding: '0 16px' }}
          >
            <Input
              className='input'
              placeholder='输入新密码'
              type={visibleNew ? 'text' : 'password'}
              value={newPassword}
              onChange={val => handleInputChange('newPassword', val)}
            />
            <div className='eye'>
              {!visibleNew ? (
                <img
                  src="./images/eyesIcon1.png"
                  alt=""
                  onClick={() => setVisibleNew(true)}
                />
              ) : (
                <img
                  src="./images/eyesIcon2.png"
                  alt=""
                  onClick={() => setVisibleNew(false)}
                />
              )}
            </div>
          </div>
        </div>
        <div className="ModifyPassword_formItem">
          <div className="ModifyPassword_itemText">
            <div className='ModifyPassword_itemIcon'>*</div>
            确认密码：
          </div>
          <div
            className={`ModifyPassword_formInput ${errors.confirmPassword ? 'error-border' : ''}`}
            style={{ padding: '0 16px' }}
          >
            <Input
              className='input'
              placeholder='确认新密码'
              type={visibleConfirm ? 'text' : 'password'}
              value={confirmPassword}
              onChange={val => handleInputChange('confirmPassword', val)}
            />
            <div className='eye'>
              {!visibleConfirm ? (
                <img
                  src="./images/eyesIcon1.png"
                  alt=""
                  onClick={() => setVisibleConfirm(true)}
                />
              ) : (
                <img
                  src="./images/eyesIcon2.png"
                  alt=""
                  onClick={() => setVisibleConfirm(false)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div style={{ paddingBottom: '68px' }}>
        <Button
          className='ModifyPassword_btn'
          block
          loading={loading}
          onClick={onsubmit}
        >
          确认
        </Button>
      </div>
    </div>
  );
}

export default ModifyPassword;